import React, { useState } from "react"
import { dataQuestions } from "./data-questions";

import "./packaging-delivery-section-6.scss"

const PackagingDeliverySection6 = () => {

    const [valueQuestion, setValueQuestion] = useState(null);

    const handleQuestion = (value_id, value_index) => {

        if (valueQuestion === null) {
            setValueQuestion(value_id)

        } else if (valueQuestion === value_index) {
            setValueQuestion(null)

        } else if (valueQuestion !== value_index) {
            setValueQuestion(value_id)

        }

    }

    return (
        <div className="f-packaging-delivery-section-6">
            <div className="f-packaging-delivery-section-6__container">
                <h2 className="f-packaging-delivery-section-6__container-title">Preguntas frecuentes</h2>

                <div className="f-packaging-delivery-section-6__container-questionList">
                    {dataQuestions.map((question, index) => (
                        <div className={'f-packaging-delivery-section-6__container-question ' + `${valueQuestion === index + 1 ? "border-style-active" : ""}`} key={index}>
                            <div onClick={() => handleQuestion(question.idQuestion, index + 1)} className={'f-packaging-delivery-section-6__container-question__title ' + `${valueQuestion === index + 1 ? "" : "border-style"}`}>
                                <p className={`${valueQuestion === index + 1 ? "active-question" : null}`}>
                                    {question.titleQuestion}
                                </p>

                                <div className={'icon-arrow ' + `${valueQuestion === index + 1 ? "active-arrow" : ""}`}>
                                    <svg width="20" height="20">
                                        <g transform="matrix(0.0390625 0 0 0.0390625 0 0)">
                                            <path d="M-1 -1L581 -1L581 401L-1 401L-1 -1z" stroke="none" fill="none" />
                                            <path fill={`${valueQuestion === index + 1 ? "#FF409B" : "#000000"}`} d="M256 298.3L430.2 131.1C 434.5 126.9 441.6 127 446 131.3L446 131.3L476.6 161.2C 481 165.5 481.1 172.5 476.8 176.7L476.8 176.7L264.1 380.9C 261.9 383.1 258.9 384.1 256 383.9C 253 384 250.1 383 247.9 380.9L247.9 380.9L35.20003 176.7C 30.90003 172.5 31.00003 165.5 35.40003 161.2L35.40003 161.2L66.00003 131.3C 70.40003 127 77.50003 126.9 81.80003 131.1L81.80003 131.1L256 298.3z" stroke="none" fill-rule="nonzero" />
                                        </g>
                                    </svg>
                                </div>
                            </div>

                            {
                                valueQuestion === index + 1 ?
                                    <div className="f-packaging-delivery-section-6__container-question__answer">
                                        <p>
                                            {question.answerQuestion}
                                        </p>
                                    </div>
                                    : null
                            }
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default PackagingDeliverySection6;